import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiSprite from "slotworks/graphics/elements/flexi-sprite";
import SoundManager from "slotworks/sound/sound-manager";

export default class SoundToggleComponent {

    private onButton: FlexiButton;
    private offButton: FlexiButton;

    private loadingSprite: FlexiSprite;

    private muted: boolean;

    constructor(onButton: FlexiButton, offButton: FlexiButton, loadingSprite?: FlexiSprite) {
        this.onButton = onButton;
        this.offButton = offButton;

        this.onButton.on(ButtonEvent.POINTER_DOWN, this.soundOnHandler);
        this.offButton.on(ButtonEvent.POINTER_DOWN, this.soundOffHandler);

        this.loadingSprite = loadingSprite;
        if (this.loadingSprite) {
            this.loadingSprite.setVisible(false);
        }

        SoundManager.onMuteChange.add(this.setMute);

        this.setMute(SoundManager.getMuted());
    }

    public destroy() {
        this.onButton.off(ButtonEvent.POINTER_DOWN, this.soundOnHandler);
        this.offButton.off(ButtonEvent.POINTER_DOWN, this.soundOffHandler);

        SoundManager.onMuteChange.remove(this.setMute);

        SoundManager.onLoadComplete.remove(this.loadComplete);
    }

    private soundOnHandler = () => {
        this.setMute(false);
    }

    private soundOffHandler = () => {
        this.setMute(true);
    }

    private setMute = (muted: boolean) => {

        this.muted = muted;

        if (this.muted) {
            SoundManager.mute();
        } else {
            SoundManager.unmute();
        }

        this.updateSoundButtons();
    }

    private loadComplete = () => {
        if (this.loadingSprite) {
            this.loadingSprite.setVisible(false);
        }

        SoundManager.onLoadComplete.remove(this.loadComplete);
        this.setMute(false);
    }

    private updateSoundButtons() {
        this.offButton.setVisible(!this.muted);
        this.offButton.setEnabled(!this.muted);

        this.onButton.setVisible(this.muted);
        this.onButton.setEnabled(this.muted);

        this.waitForSoundsToLoad();
    }

    private waitForSoundsToLoad() {
        if (SoundManager.getLoading()) {
            this.onButton.setVisible(false);
            this.onButton.setEnabled(false);
            this.offButton.setVisible(false);
            this.offButton.setEnabled(false);

            if (this.loadingSprite) {
                this.loadingSprite.setVisible(true);
            }

            SoundManager.onLoadComplete.add(this.loadComplete);
        }
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/sound/sound-toggle-component.ts